import script from "./ShareCustomDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareCustomDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ShareCustomDashboard.vue?vue&type=style&index=0&id=66a41e90&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a41e90"]])

export default __exports__